import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const requestSignupOtp = async (formData) => {
  const res = await axios.post(`${BASE_URL}/signup`, formData);
  return res.data;
};

export const verifySignupOtp = async (email, otp) => {
  const res = await axios.post(`${BASE_URL}/verify-otp`, { email, otp });
  return res.data;
};

export const resendSignupOtp = async (email) => {
  const res = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/user/resend-otp`, { email });
  return res.data;
};
